import React from "react";

import LocFrame from "../../../misc/loc-iframe/LocFrame";

const AccessibiltyNavigation = ({ accessabilityEntry, roomID }) => {
  /**
   * Method to compile the dataset from backend to a valid html file. This is a workaround to handle the data quality.
   * @param {string} content to be wrapped.
   * @returns Compiled HTML file.
   */
  const wrapInHTML = (content) => {
    return `<!DOCTYPE html>
    <html>
      <head>
      </head>
      <body>
        <style>
          * {
            font-family: "Inter", sans-serif;
            font-size: 1rem;
            color: #f5f5f5;
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          body {
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 8px;
          }
          
          b, i {
            color: inherit;
          }

          img,
          iframe {
            width: 100%;
            border-radius: 8px;
            box-shadow: 0 0 24px rgba(16, 16, 16, 1);
          }

          .tab,
          .subtab  {
            border-top: 1px solid #f5f5f5;      
            border-bottom: 1px solid #f5f5f5;
            width: 100%;
            overflow-x: auto;
            display: flex;
            flex-wrap: wrap;
            padding: 8px;
          }    
          
          .subtab {        
            border-top: none;
          }
          
          .tab button, .subtab button {
            width: 100%;
            background-color: inherit;
            border: none;
            border-radius: 8px;
            outline: none;
            cursor: pointer;
            padding: 16px 8px;
            transition: 0.3s;
            display: inline-block;
          }
          
          .tab button:hover, .subtab button:hover,
          .tab button:focus, .subtab button:focus,
          .tab button.active, .subtab button.active  {
            background-color: rgba(236, 179, 101, 0.24);
            color: #ecb365;
          }
          
          .tabcontent, .subtabcontent {
            width: 100%;
            padding: 16px;
            display: none;
            border-top: none;
          }
          
          .tabcontent {
            padding-top: 0;
          }
        </style>
        ${content}
      </body>
      </html>`;
  };

  const retrieveValueFromEntry = () => {
    const origin = accessabilityEntry;
    //const regex_img = new RegExp("<img.s*.*/>", "g"); //Regex to fetch all img tags
    //const regex_iframe = new RegExp("<iframes*.*>s*.*</iframe>", "g"); //Regex to fetch all iframes with the embedded google maps

    if (origin !== null && origin !== undefined) {
      const style_str = origin.substring(
        origin.indexOf("<style>"),
        origin.lastIndexOf("</style>") + 9,
      );

      const alteredOrigin = origin
        .replace(style_str, "") // Exclude all <style> attributes to apply custom styling afterwards
        .replaceAll(
          "http://www.uni-regensburg.de/Einrichtungen/TZ/",
          "https://famos.app.uni-regensburg.de/",
        ); // Manually transform all "old" image URL's to the "new" one's
      return wrapInHTML(alteredOrigin);
    }
  };

  return (
    <div>
      {/* Display the compiled html file in an individualized iFrame. */}
      <LocFrame
        roomID={roomID}
        source={retrieveValueFromEntry()}
        title={"Beschreibung der barrierefreien Zugangsmöglichkeiten"}
      />
    </div>
  );
};

export default AccessibiltyNavigation;
